import { Filters } from "./filters";
import { Summary } from "./summary";
import { Columns } from "./columns";
import { SubReports } from "./sub-reports";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const SalesPipelineReportConfig: ReportConfigBase = {
  type: EReportTypes.SalesPipeline,
  endpoint: "report/sales-pipeline",
  filtersBase: Filters,
  summaryBase: Summary,
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "The Sales Pipeline Report offers an overview of pre-sales performance for yourself or your team.",
    url: "https://help.commonsku.com/knowledge/sales-pipeline",
  },
  subReports: {
    configs: SubReports,
    titleTemplate: (rowData: Record<string, any>) => "Rep Summary",
  },
};

export default SalesPipelineReportConfig;
